var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkShield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27005 8.44998L2.21395 6.39388L2.93872 5.66911L4.27005 6.99529L7.65747 3.60787L8.38224 4.33778M5.2981 0.225586L0.671875 2.28168V5.36583C0.671875 8.21867 2.64573 10.8865 5.2981 11.5341C7.95046 10.8865 9.92432 8.21867 9.92432 5.36583V2.28168L5.2981 0.225586Z",
    fill: "#EECA30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkShield);
export default __webpack_public_path__ + "static/media/check-mark-shield.39884426fe11e9aecbf64349aeda5592.svg";
export { ForwardRef as ReactComponent };